export default function Footer() {
  return (
    <footer className="seafloor py-3">
      <p className="fw-semibold text-center">&copy; 2025 Marco Yu</p>
    </footer>
  );
}
